<p> BE version: {{version.version}}</p>
<p> BE uptime: {{msToTime(version.uptime)}}</p>
<p> FE version:{{feVersion.hash}}</p>


